export default __webpack_public_path__ + "static/resource3-93a24a9290d7354a6ba12b8f6702416d.png";